import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../../store/actions/notificationAction';

import queueRemote from '../../../api/queueRemote';

import DriverQueueList from './DriverQueueList';

import DriverQueue, { ResultDriverQueue } from '../../../models/DriverQueue';
import ApiResponse from '../../../models/ApiResponse';
import ResponseError from '../../../models/ResponseError';

import environments from '../../../configs/environments';

import commonStyles from '../../common/common.module.css';
import GhaModel from '../../../models/Gha';

interface DriverQueueListContainerProps {
  receiveError: Function;
  gha: GhaModel;
};

interface DriverQueueListContainerState {
  queue: Array<DriverQueue>;
};

class DriverQueueListContainer extends Component<DriverQueueListContainerProps, DriverQueueListContainerState> {

  intervalID: number | undefined;

  state: DriverQueueListContainerState = {
    queue: []
  }

  componentDidMount() {
    this.intervalID = window.setInterval(
      () => this.getQueue(),
      environments.refreshInterval
    );
    this.getQueue();
  }

  componentWillUnmount() {
    clearInterval(this.intervalID);
  }

  getQueue = () => {
    queueRemote.getQueue('check_in').then((resp: ApiResponse<ResultDriverQueue>) => {

      const result : ResultDriverQueue | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (result) {
        this.setState({ queue: result.queue })
      }
      
      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  render () {
    return (
      <div>
        <div className= { commonStyles.headerDummyDiv }> </div>
        <DriverQueueList 
          queue={ this.state.queue }
          type={ 'queue' }
          airlines={ [] }
          selectedAirlines={ [] }
          handleChange={ () =>{} }
          showAirlineFilter={ false }
        />
      </div>
      
    )
  }
}

const mapStateToProps = (state: any) => {
  return {
    gha: state.ghaInfo
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DriverQueueListContainer);